import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=34b7b57f&"
import script from "./Paginate.js?vue&type=script&lang=js&"
export * from "./Paginate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports